import type { FieldDto, FieldValueDto } from '@lib/dto/envelope.dto'

function emptyValue(field: FieldDto): FieldValueDto | undefined {
  if (field.type === 'checkbox') {
    return false
  }
  return field.value ?? undefined
}

/**
 * Values to show when a signing session becomes ready. A saved signature or
 * initials is kept. An empty stamp is left unset, so the next save does not
 * wipe ink that is already stored.
 */
export function seedDraftValues(
  fields: readonly FieldDto[],
  signerId: string,
): Record<string, FieldValueDto> {
  const next: Record<string, FieldValueDto> = {}
  for (const field of fields) {
    if (field.signerId !== signerId) {
      continue
    }
    if (field.type === 'signature' || field.type === 'initials') {
      if (field.value && field.value.data.trim().length > 0) {
        next[field.id] = field.value
      }
      continue
    }
    if (field.type === 'date_signed') {
      continue
    }
    const seed = emptyValue(field)
    if (seed !== undefined) {
      next[field.id] = seed
    }
    if (field.value != null) {
      next[field.id] = field.value
    }
  }
  return next
}
